import React, { useState } from "react";
import "./ParentStyle.css";
import Accordion from "./Accordion.js";
import Tabs from "./Tabs.js"; 
import { sections, payloadData } from './data.js';

export default function ParentComp() {
  const [selectedKey, setSelectedKey] = useState(null);
  const [openSection, setOpenSection] = useState(null);

  const handleToggle = (sectionTitle) => {

    console.log("check sectionTitle", sectionTitle),
    console.log("check selectedKey", selectedKey)

    if (sectionTitle === "V1" && !selectedKey) {
      setSelectedKey("installation");
    }
    setOpenSection((prevSection) =>
      prevSection === sectionTitle ? null : sectionTitle
    );
  };

  const tabsData = [
    { label: "Vanilla JS", key: "Vanilla_JS" },
    { label: "React JS", key: "React_JS" },
  ];

  return (
    <div className="container">
      <div className="bottom-row">
        <div className="leftBox">
          {Object.keys(sections).map((sectionTitle) => (
            <Accordion
              key={sectionTitle}
              title={sectionTitle}
              options={sections[sectionTitle]}
              onSelect={setSelectedKey}
              isOpen={openSection === sectionTitle}
              onToggle={() => handleToggle(sectionTitle)}
              selectedKey={selectedKey}
            />
          ))}
        </div>
        <div className="rightBox">
          <div className="right_header">
            <Tabs tabs={tabsData} payload={payloadData} selectedKey={selectedKey} />
          </div>
        </div>
      </div>
    </div>
  );
}
